import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IUser } from 'app/shared/model/user.model';

export interface IVehiclePositionLast {
  id?: number;
  created?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  odometer?: number | null;
  speed?: number | null;
  vBat?: number | null;
  vSupply?: number | null;
  supplyOn?: number | null;
  activated?: boolean | null;
  gpsFix?: boolean | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<IVehiclePositionLast> = {
  activated: false,
};
